import { GetTimeDifferenceFromNow } from '@/utils/helpers'
export default {
  data () {
    return {
      tokenTimeout: null
    }
  },
  methods: {
    async refreshToken (payload) {
      await this.$store
        .dispatch('auth/refreshToken', payload)
        .then(() => {
          clearTimeout(this.tokenTimeout)
          this.refreshTokenTimeout()
        })
        .catch((error) => {
          this.handleErrorResponseNotification(error)
        })
    },
    refreshTokenTimeout () {
      clearTimeout(this.tokenTimeout)
      const expireTokenTime = this.$store.state.auth.tokenExpiry
      const timeDifference = GetTimeDifferenceFromNow(expireTokenTime)
      this.tokenTimeout =
        this.$route.name === 'accountSetup' ||
        this.$route.name.includes('submit-kyc')
          ? setTimeout(
              () => this.refreshToken(this.$store.state.auth.keepMeLoggedIn),
              timeDifference
            )
          : null
    }
  },
  destroy () {
    clearTimeout(this.tokenTimeout)
  }
}
